<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col
              ><v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field
            ></v-col>
            <v-col
              cols="12"
              md="4"
              xl="2"
              sm="12"
              @click="changeAction(2)"
              v-if="$utilFront.withPermission($prm.ADD_CONSULTING_ROOM)"
            >
              <btn-accion :elements="btnAdd" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': 'Elementos por página',
            'items-per-page-all-text': 'Todo',
          }"
          no-results-text="Sin resultados coincidentes con el búsqueda"
          loading-text="Cargando..."
          no-data-text="Sin resultados disponibles"
          class="mx-5"
          dense
          fixed-header
          height="auto"
        >
          
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top v-if="$utilFront.withPermission($prm.MODULE_CONF)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="checkProcedure(item)" x-small>
                  <v-icon color="blue" v-bind="attrs" v-on="on">
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Editar información</span>
            </v-tooltip>
            <span v-else> - - - </span>
          </template>
        </v-data-table>
      </v-card>
      <encabezado
        :elementos="encabezado"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de procedimiento"
                    rules="required|max:150"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="150"
                      :error-messages="errors"
                      label="Nombre de Procedimiento"
                      required
                      autocomplete="off"
                      @input="
                        if (dataModal.name)
                          dataModal.name = $event.toUpperCase();
                      "
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Tipo de procedimiento"
                    rules="required"
                  >
                    <v-select
                      v-model="dataModal.type"
                      :item-text="types.text"
                      :item-value="types.value"
                      :items="types"
                      :error-messages="errors"
                      label="Tipo de procedimiento"
                      required
                    ></v-select>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Color (#HEX)"
                    rules="max:7"
                  >
                    <v-text-field
                      v-model="dataModal.color"
                      :counter="7"
                      :error-messages="errors"
                      label="Color (#HEX)"
                      autocomplete="off"
                      @input="
                        if (dataModal.color)
                          dataModal.color = $event.toUpperCase();
                      "
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Tipo de Atención"
                    rules="required"
                  >
                    <v-autocomplete
                      v-if="showAction(2)"
                      v-model="dataModal.attentionType"
                      label="Tipo de Atención"
                      :items="listAttentionType"
                      :item-text="listAttentionType.text"
                      :item-value="listAttentionType.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                      v-if="showAction(3)"
                      v-model="dataModal.attentionTypeDTO.idAttentionType"
                      label="Tipo de Atención"
                      :items="listAttentionType"
                      :item-text="listAttentionType.text"
                      :item-value="listAttentionType.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn
                  type="submit"
                  :disabled="sending || invalid"
                  color="success"
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import AutoLogout from "../../components/AutoLogout.vue";
import { ProcedureRequest, StudyModalityRequest } from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import Loader from "../../components/Loader.vue";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "Perfiles",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    ExportImportBtn,
    Loader,
    ProcedureRequest,
  },
  data() {
    return {
      importDialog: false,
      dialog: false,
      search: "",
      dataModal: {},
      action: 1,
      encabezado: {
        icono: "mdi-menu",
        texto: "Procedimientos Dentales",
      },
      list: [],
      listAttentionType: [],
      sending: false,
      dialogs: {
        title: "¿Desea modificar el estatus?",
        text: "El procedimiento será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
      },
      headers: [
        { text: "ID Procedimiento", value: "idProcedure", align: "center" },
        { text: "Nombre", value: "name", align: "center" },
        { text: "Tipo de Procedimiento", value: "typeName", align: "center" },
        { text: "Tipo de Atención", value: "attentionType", align: "center" },
        { text: "Acciones", value: "actions", sortable: false, align: "center" },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Procedimiento",
        tooltip: "Agregar Procedimiento",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar procedimiento",
      service: ProcedureRequest,
      updateModal: false,
      results: {},
      fileXls: null,
      types: [
        { text: "Por pieza dental", value: 0 },
        { text: "Obligatorio", value: 1 },
        { text: "Por consulta", value: 2 },
        { text: "Opcional", value: 3 },
      ],
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
    this.listAttenttionTypes();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.dataModal = {};
      } else if (action == 2) {
        this.dataModal = {};
      } else if (action == 3) {
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Procedimientos",
          };
          this.dialogs = {
            title: "¿Desea modificar el estatus?",
            text: "El procedimiento será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Registrar procedimiento",
          };
          this.dialogs = {
            title: "¿Desea registrar éste procedimiento?",
            text: "El procedimiento será registrado de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar procedimiento";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Editar procedimiento",
          };
          this.dialogs = {
            title: "¿Desea modificar éste procedimiento?",
            text: "El procedimiento será modificado de inmediato y podría afectar a los registros que dependan de él",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar procedimiento";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Procedimientos",
          };
          break;
      }
    },
    doAction() {
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    sendData() {
      this.sending = !this.sending;
    },

    listAttenttionTypes() {
      this.service.listAttentionTypes().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listAttentionType = res.data.data.map((attentionType) => {
            return {
              value: attentionType.idAttentionType,
              text: attentionType.name,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listAll() {
      this.service.listAllProcedures().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((procedure) => {
            return {
              idProcedure: procedure.idProcedure,
              name: procedure.name,
              attentionType: procedure.attentionType,
              color: procedure.color,
              type: procedure.type,
              attentionTypeDTO: procedure.attentionTypeDTO,
              typeName:
                procedure.type == 0
                  ? "Por pieza dental"
                  : procedure.type == 1
                  ? "Obligatorio"
                  : procedure.type == 2
                  ? "Por consulta"
                  : "Opcional",
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          name: this.dataModal.name.trim(),
          status: 1,
          type: this.dataModal.type,
          color: this.dataModal.color.trim(),
          attentionType: {
            idAttentionType: this.dataModal.attentionType,
          },
        };
        ProcedureRequest.addProcedure(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Procedimiento registrado correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          idProcedure: this.dataModal.idProcedure,
          name: this.dataModal.name.trim(),
          status: 1,
          type: this.dataModal.type,
          color: this.dataModal.color.trim(),
          attentionType: {
            idAttentionType: this.dataModal.attentionTypeDTO.idAttentionType,
          },
        };
        ProcedureRequest.updateProcedure(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Procedimiento modificado correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

    checkProcedure(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.changeAction(3);
    },
  },
  computed: {},
};
</script>
